import { render, staticRenderFns } from "./fqMall.vue?vue&type=template&id=64120afc&"
import script from "./fqMall.vue?vue&type=script&lang=ts&"
export * from "./fqMall.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports